"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Admin = void 0;
var react_1 = __importDefault(require("react"));
var messageContext_1 = require("../hoc/messageContext");
var react_router_dom_1 = require("react-router-dom");
var authorizationProvider_1 = require("../hoc/authorizationProvider");
var Admin = function () {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(messageContext_1.MessageProvider, null,
            react_1.default.createElement(authorizationProvider_1.AuthorizationProvider, null,
                react_1.default.createElement(react_router_dom_1.Outlet, null)))));
};
exports.Admin = Admin;
